import { render, staticRenderFns } from "./ContentCopyIcon.vue?vue&type=template&id=25e5f9a9"
import script from "./ContentCopyIcon.vue?vue&type=script&lang=js"
export * from "./ContentCopyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports